<template>
  <div class="hide-on-print">
		<!-- Page Title -->
		<page-title
			icon="ni ni-chart-bar-32"
			main="Relatórios"
			sub="Clientes"
		>
    </page-title>

		<!-- Filter -->
		<card>
			<div slot="header" class="row align-items-center">
				<div class="col">
					<h5 class="h3 mb-0">Pesquisar Cliente</h5>
				</div>
			</div>
			<div class="row">
				<div class="col-3">
					<label class="form-control-label">Tipo de Cliente</label>
					<multiselect
            v-model="filter.client_type"
            :options="clientTypes"
						placeholder="Cliente"
						label="name"
						:select-label="''"
						:deselect-label="''"
						:selected-label="'Selecionado'"
						track-by="code"
					></multiselect>
				</div>
        <div class="col-3">
					<label class="form-control-label">Cliente</label>
					<multiselect
            v-model="filter.client"
            :options="clients"
						placeholder="Cliente"
						label="name"
						:select-label="''"
						:deselect-label="''"
						:selected-label="'Selecionado'"
						track-by="code"
					></multiselect>
				</div>
        <div class="col-md-4">
          <div style="margin-top: 1.8rem">
            <base-button icon @click="filterClient" type="purple" style="width: 50%">
              <span class="btn-inner--text text-white">Pesquisar</span>
            </base-button>
             <base-button type="secondary" class="ml-2"  @click="exportToExcel()">Gerar Excel</base-button>
          </div>
        </div>
			</div>
		</card>
    <card>
      <div>
        <el-table
          class="table-responsive clickable-rows"
          :border="false"
          :data="clients"
          :stripe="true"
          v-loading="loadingClients"
        >
          <el-table-column label="Nome" prop="name" sortable />
          <el-table-column label="Tipo" prop="type" sortable v-slot="{ row }">
            {{ row.type ? row.type.toUpperCase() : '' }}
          </el-table-column>
          <el-table-column label="Porte" prop="size" sortable v-slot="{ row }">
            {{ row.size ? row.size.toUpperCase() : '' }}
          </el-table-column> 
          <el-table-column label="Score" prop="score" sortable />
          <el-table-column label="Quantidade de Propostas" sortable prop="proposals_count"></el-table-column>
        </el-table>
        <div class="card-footer py-4 d-flex justify-content-end">
          <base-pagination>
          </base-pagination>
        </div>
      </div>
    </card>
	</div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle"
import { Table, TableColumn, Tag }from "element-ui"
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
export default {
  name: 'clients-report',
  components: { 
    PageTitle,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
    [Tag.name]: Tag,
    Multiselect
  },
  data() {
    return {
      clients: [],
      clientTypes: [],
      filter: {},
      loadingClients: false
    }
  },
  mounted () {
    this.getClientsCri()
    this.getClientTypes()
  },
  methods: {
    exportToExcel() {
      return this.$exportToExcel();
    },
    filterClient() {
      const client_type_id = this.filter.client_type ? this.filter.client_type.id : null
      const id = this.filter.client ? this.filter.client.id : null
      this.getClientsCri(id, client_type_id)
    },
    async getClientsCri (id=null, client_type_id=null) {
      this.loadingClients = true
      const data = {
        query: {},
        page: 1,
        per_page: 10
      }

      if (id != null) {
        data.query.id = id
      }
      if (client_type_id != null) {
        data.query.client_type_id = client_type_id
      }
      
      const response = await this.$http.secured.get("/api/v1/credit_analysis/get_clients", { params: data })
      this.clients = response.data
      this.loadingClients = false
    },
    async getClientTypes () {
      const response = await this.$http.secured.get("/api/v1/credit_analysis/get_client_types")
      this.clientTypes = response.data
    },
  }
}
</script>

<style>

</style>